import {UserTypeConstants} from '../../shared/user-type-constants';

export class UserUtil {
  static isDwnCustomer(userType: string): boolean {
    return userType === UserTypeConstants.DWN_USER;
  }

  static isSohoCustomer(userType: string): boolean {
    return userType === UserTypeConstants.BUSINESS_USER;
  }
}
